<template>
    <div class="fs-sidebar">
      <div class="example editor" 
      @click="openNew()"
      @mouseover="editNew=true" @mouseleave="editNew=false">
        <span v-if="!editNew" class="material-symbols-outlined">draft</span>
        <span v-if="editNew" class="material-symbols-outlined">edit_document</span>
        <span class="text">{{ $t('Filter.New') }}</span>
      </div>
      <div class="example editor" 
      @click="openNew()"
      @mouseover="deleteFile=true" @mouseleave="deleteFile=false">
        <span v-if="!deleteFile" class="material-symbols-outlined">delete</span>
        <span v-if="deleteFile" class="material-symbols-outlined">delete_forever</span>
        <span class="text">{{ $t('Filter.Delete') }}</span>
      </div>
      <div class="example editor" 
      @click="createFolder()"
      @mouseover="editNewFolder=true" @mouseleave="editNewFolder=false">
        <span v-if="!editNewFolder" class="material-symbols-outlined">folder</span>
        <span v-if="editNewFolder" class="material-symbols-outlined">create_new_folder</span>
        <span class="text">{{ $t('Filter.NewFolder') }}</span>
      </div>
      <div class="example editor" @mouseover="folderOpen=true" @mouseleave="folderOpen=false">
        <label for="file-upload" class="custom-file-upload" >
        <span v-if=folderOpen  true class="material-symbols-outlined">folder_open</span>
        <span v-if=!folderOpen class="material-symbols-outlined">folder</span>
        <span class="text">{{ $t('Filter.OpenFile') }}</span>
        </label>
        <input id="file-upload" type="file" accept=".edepp, .json" @change="handleFileUpload" />
      </div>
      <div class="container-wrapper">
      <Preview v-if="previewData" class="container" :emailData="previewData"/>
      <div v-else>
        <p>Click on template for preview</p>
      </div>
    </div>
    </div>
  </template>
  
  <script setup>
  import JSZip from 'jszip';
  import Preview from '../Preview.vue';
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const editNew = ref(false)
  const editNewFolder = ref(false)
  const folderOpen = ref(false)
  const deleteFile = ref(false)
  const store = useStore()
  const emit = defineEmits(['createFolder'])

  const previewData = computed(()=>store.state.previewData)


  const handleFileUpload = async (event) =>  {
  /* folderOpen = true; */
  const file = event.target.files[0];
  if (file) {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (fileExtension === 'edepp') {
      try {
        const blob = file.slice(0, file.size, 'application/zip');
        const zip = new JSZip();
        const content = await zip.loadAsync(blob);
        const jsonFile = Object.keys(content.files).find(filename => filename.endsWith('.json'));
        if (jsonFile) {
          const jsonData = await content.files[jsonFile].async('string');
          const json = JSON.parse(jsonData);
          if (json.root) {
            if (json.mediaQueries) {
            store.commit('setMediaQueries', json.mediaQueries);
            delete json.mediaQueries;
            }
            if (json.mapping) {
            store.commit('setXPathPlaceholders', json.mapping);
            delete json.mapping;
            }
            store.dispatch('updateEmailData', json)
            store.commit('setView', 'Edit')
            store.dispatch('updateEmailTitle', file.name.split('.').slice(0, -1).join('.'))  
            
          } else {
            this.showErrorMessage('Invalid JSON file inside the .edepp: Missing root element');
          }
        } else {
          this.showErrorMessage('No JSON file found inside the .edepp');
        }
      } catch (error) {
        console.error('Error reading .edepp file:', error);
        this.showErrorMessage('Error processing .edepp file');
      }
    } else {
      this.showErrorMessage('Unsupported file type. Please upload a .json or .edepp file.');
    }
  }
  store.dispatch('resetSharedData')
}


const createFolder = () => {
  emit('createFolder')
}
const openNew = () => {
  store.dispatch('updateExampleMail', '/emptyMail.json')
  store.commit('setView', 'Edit')
  store.dispatch('resetEmailTitle')
  store.dispatch('resetSharedData')
}
  
  </script>
  
  <style scoped>
  .fs-sidebar {
    display: flex;
    flex-direction: column;
  }
  
  button {
    padding: 8px 16px;
    font-size: 14px;
  }


  .container-wrapper {
    width: calc(1000px * 0.5); /* Effektive Breite (hier 500px) */
    min-height: 60vh;
    max-height: 60vh;
    position: relative;
     overflow: hidden;
     box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}

/* Das Overlay wird am unteren Rand des Wrappers positioniert */
.container-wrapper::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%; /* passt sich der Wrapperbreite an */
  height: 40%; /* passt sich der effektiven Höhe an */
  background: linear-gradient(to top, #ffffff, transparent);
  pointer-events: none; /* blockiert keine Mausklicks */
}

.container {
  width: 1000px;
  max-height: 50%;
  overflow-x: hidden;
  transform: scale(0.5, 0.5);
  transform-origin: top left;
}

  .example {
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 15px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.example:hover{
  background-color: #cccc !important;
}


.custom-file-upload{
  display: flex;
  align-items: center;
  gap: 15px;
}


#file-upload {
  display: none;
  
}


  </style>
  